import { put, takeLatest } from "redux-saga/effects";
import { postFeedBackApi } from "store/api/FeedBackApi";
import { FEED_BACK_ACTION } from "../../actions/FeedBackPageAction/actionTypes";

import * as globalAction from "../../actions/GlobalAction";

function* errorMessage(message) {
	const alert = { isError: true, message: message, isOpenAlert: true };
	yield put(globalAction.setAlertMessage(alert));
}

function* postFeedBack(action) {
	const { business, feedback, rating, shopId, success } = action.params;
	const data = {
		business: business,
		feedback: feedback,
		rating: rating,
		shopId: shopId
	};
	const res = yield postFeedBackApi(data);
	try {
		if (res?.code === 0) {
			success();
		} else {
			yield errorMessage(res?.message);
		}
	} catch (e) {
		console.log(e);
	}
}

function* postFeedBackSaga() {
	yield takeLatest(FEED_BACK_ACTION, postFeedBack);
}

export default postFeedBackSaga;
